const stockOutId = {
	stock_out: {
		title: "Stok Keluar",
		subtitle: "Ringkasan daftar stok keluar",
	table: {
		title: "Data Stock Keluar",
		columns: {
			date: "Tanggal",
			ref_id: "Ref ID",
			store: "Toko",
			notes: "Catatan",
			created_by: "Dibuat Oleh",
			status: "Status",
		},
	},
		empty_state: {
			title: {
				has_filter: "Tidak ada data yang sesuai",
				no_filter: "Tidak ada data stok keluar",
			},
			description: {
				has_filter:
					"Tidak ditemukan data dengan filter yang dipilih. Coba ubah filter Anda.",
				no_filter: "Silakan tambahkan data stok keluar baru.",
			},
		},
	forms: {
		edit: {
			title: "Edit Stok Keluar",
			info: "Informasi stok keluar",
			fields: {
				ref_id: {
					label: "RefId",
					placeholder: "refId",
				},
				store: {
					label: "Toko",
					placeholder: "Pilih Toko",
				},
				notes: {
					label: "Catatan",
					placeholder: "catatan",
				},
				status: {
					label: "Status",
					placeholder: "Pilih status",
				},
			},
			options: {
				active: "Aktif",
				inactive: "Tidak Aktif",
			},
		},
		add: {
				button: "Tambah Stok Keluar",
				title: "Tambah Stok Keluar",
				description: "Tambah data Stok Keluar baru",
				fields: {
					store: {
						label: "Toko",
						placeholder: "Pilih toko",
					},
					notes: {
						label: "Catatan",
						placeholder: "Masukkan Catatan",
					},
					processed_at: {
						label: "Tanggal proses",
					},
					product_detail: {
						title: "Detail Produk",
						loading: "Memuat produk...",
						product: {
							label: "Produk",
							placeholder: "Pilih Produk",
							search_product: "Cari Produk...",
							not_found_product: "Tidak ada product yang ditemukan",
						},
						qty: {
							label: "QTY",
							placeholder: "0",
						},
						unit: {
							label: "Satuan",
							placeholder: "Pcs",
						},
						action: {
							label: "Aksi",
						},
					},
				},
			},
		},
		actions: {
			save: "Simpan",
			saving: "Menyimpan...",
			cancel: "Batal",
			save_changes: "Simpan Perubahan",
			add_products: {
				already_added: "Produk ini sudah ditambahkan",
				button: "Tambahkan Produk lagi",
			},
		},
		status: {
			processed: "Sudah diproses",
			inactive: "Tidak Aktif",
		},
	},
};

export default stockOutId;
